var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_233_4678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_233_4678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 16.333C7.71421 16.333 8.8335 15.2137 8.8335 13.833C8.8335 12.4523 7.71421 11.333 6.3335 11.333C4.95278 11.333 3.8335 12.4523 3.8335 13.833C3.8335 15.2137 4.95278 16.333 6.3335 16.333Z",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83341 13.8333H13.8334M13.8334 13.8333V4.66667C13.8334 4.22464 13.6578 3.80072 13.3453 3.48816C13.0327 3.17559 12.6088 3 12.1667 3H3.83341C3.39139 3 2.96746 3.17559 2.6549 3.48816C2.34234 3.80072 2.16675 4.22464 2.16675 4.66667V13C2.16675 13.221 2.25455 13.433 2.41083 13.5893C2.56711 13.7455 2.77907 13.8333 3.00008 13.8333H3.83341M13.8334 13.8333V6.33333H15.5001C16.3841 6.33333 17.232 6.68452 17.8571 7.30964C18.4822 7.93477 18.8334 8.78261 18.8334 9.66667V13C18.8334 13.221 18.7456 13.433 18.5893 13.5893C18.4331 13.7455 18.2211 13.8333 18.0001 13.8333M13.8334 13.8333H18.0001M18.0001 13.8333C18.0001 14.4964 17.7367 15.1323 17.2678 15.6011C16.799 16.0699 16.1631 16.3333 15.5001 16.3333C14.837 16.3333 14.2012 16.0699 13.7323 15.6011C13.2635 15.1323 13.0001 14.4964 13.0001 13.8333H18.0001ZM18.8334 11.3333H17.1667",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicles);
export default __webpack_public_path__ + "static/media/vehicles.f13ffcd4e7437bc02383a7d1ab8e275c.svg";
export { ForwardRef as ReactComponent };